// toggles site view from designer to dev
export const toggleMode = () => {
    return {
        type: 'TOGGLE-DEV-MODE'
    }
}

// sets site view explicitly (true = developer, false = designer)
export const setMode = (isDev) => {
    return {
        type: 'SET-DEV-MODE',
        payload: isDev,
    }
}

// toggle active filters (filters selected by user)
export const toggleProjectFilter = (filter) => {
    return {
        type: 'TOGGLE-FILTER',
        payload: filter,
    }
}

// removes all active filters
export const resetFilters = () => {
    return {
        type: 'RESET-FILTERS'
    }
}